/**
 * Типы экшнов, которые можно назначить конкретному шагу через его схему
 * */
export var EQuestionActionsTypes;

(function (EQuestionActionsTypes) {
  EQuestionActionsTypes["NextQ"] = "nextQ";
  EQuestionActionsTypes["Skip"] = "skip";
})(EQuestionActionsTypes || (EQuestionActionsTypes = {}));